import { ListMagnifyingGlassIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const SearchMenu = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <ListMagnifyingGlassIcon size={Sizes[size]} {...rest} />;
};

SearchMenu.displayName = 'SearchMenu';
